import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;          // e.g. https://xxxxx.supabase.co
const key = process.env.REACT_APP_SUPABASE_ANON_KEY;     // anon public key

if (!url) console.error('❌ Missing REACT_APP_SUPABASE_URL');
if (!key) console.error('❌ Missing REACT_APP_SUPABASE_ANON_KEY');

export const supabase = createClient(url, key);

